namespace TabAurous.ProductDevelopment {
    export namespace SpecSheetItemsService {
        export const baseUrl = 'ProductDevelopment/SpecSheetItems';

        export declare function Create(request: Serenity.SaveRequest<SpecSheetItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SpecSheetItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SpecSheetItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SpecSheetItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomList(request: ProductRequest, onSuccess?: (response: Serenity.ListResponse<SpecSheetItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ProductDevelopment/SpecSheetItems/Create",
            Update = "ProductDevelopment/SpecSheetItems/Update",
            Delete = "ProductDevelopment/SpecSheetItems/Delete",
            Retrieve = "ProductDevelopment/SpecSheetItems/Retrieve",
            List = "ProductDevelopment/SpecSheetItems/List",
            CustomList = "ProductDevelopment/SpecSheetItems/CustomList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'CustomList'
        ].forEach(x => {
            (<any>SpecSheetItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
